import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultJourneyActionButtonGooglePayDisplayText = {
    failedToLoadPassTitle: 'Failed to get your Google Pay pass',
    failedToLoadPassMessage: 'Please try again later.'
};
export const journeyActionButtonGooglePayDisplayTextValidator = Validator.object({
    failedToLoadPassTitle: nonEmptyStringValidator,
    failedToLoadPassMessage: nonEmptyStringValidator
});
